<template lang="pug">
b-input-group(:prepend="!removePrepend ? $t('ui.'+ preText) : ''" size="sm")
  date-range-picker(
    v-model="dateRange"
    :opens="opens"
    :singleDatePicker="singleDatePicker"
    :showWeekNumbers="showWeekNumbers"
    :autoApply="autoApply"
    :linkedCalendars="linkedCalendars"
    @update="handleInput"
    :maxDate="maxDate"
    :showDropdowns="true"
    :class="{ 'w-100' : removePrepend }"
  )
    div(slot="input" slot-scope="dateRange" style="min-width:170px;")
      i.glyphicon.glyphicon-calendar.fa.fa-calendar.mr-3
      //- span.text-right {{ $moment(dateRange.startDate).format('YYYY-MM-DD') }} - {{ $moment(dateRange.endDate).format('YYYY-MM-DD') }}
      template(v-if="singleDatePicker")
        span.text-right {{ dateRange.startDate ? $moment(dateRange.startDate).format('YYYY-MM-DD') : '' }}
      template(v-else)
        span.text-right {{ dateRange.startDate ? $moment(dateRange.startDate).format('YYYY-MM-DD') : '' }} - {{ dateRange.endDate ? $moment(dateRange.endDate).format('YYYY-MM-DD') : '' }}
    //- ranges (new slot syntax)
    template(#ranges='ranges')
      .ranges
        ul
          template(v-for='(range, name, index) in ranges.ranges')
            li(v-if="!['This year'].includes(name)" :key='name' @click='ranges.clickRange(range)')
              span {{ showLabel(index) }}

              //- b {{ name }}
              //- small.text-muted
              //-   | {{ range[0].toDateString() }} -
              //-   | {{ range[1].toDateString() }}

</template>

<script>
import DateRangePicker from 'vue2-daterange-picker';

export default {
  components: {
    DateRangePicker
  },
  props: {
    opens: {
      type: String,
      default: "right"
    },
    singleDatePicker: {
      type: Boolean,
      default: false
    },
    showWeekNumbers: {
      type: Boolean,
      default: false
    },
    linkedCalendars: {
      type: Boolean,
      default: true
    },
    autoApply: {
      type: Boolean,
      default: true
    },
    format: {
      type: String,
      default: "YYYY-MM-DD"
    },
    minuteStep: {
      type: Number,
      default: 1
    },
    value: {
      type: Object,
      default: null
    },
    preText: {
      type: String,
      default: "date"
    },
    maxDate: {
      type: String,
      default: null
    },
    removePrepend: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dateRange: this.value,
      ranges: {
        'Today': [this.$moment(), this.$moment()],
        'Yesterday': [this.$moment().subtract(1, 'days'), this.$moment().subtract(1, 'days')],
        'This month': [this.$moment().startOf('month'), this.$moment().endOf('month')],
        // 'This year': [this.$moment().startOf('year'), this.$moment().endOf('year')],
        'Last week': [this.$moment().subtract(1, 'week').startOf('week').add(1, 'days'), this.$moment().subtract(1, 'week').endOf('week').add(1, 'days')],
        'Last month': [this.$moment().subtract(1, 'month').startOf('month'), this.$moment().subtract(1, 'month').endOf('month')],
      }
    }
  },
  computed: {
    language() {
      return this.$store.getters.language;
    }
  },
  methods: {
    showLabel(item) {
      return this.$t('ui.date_ranges.' + item);
    },
    handleInput: function(currentValue) {
      this.dateRange.startDate = this.$moment(currentValue.startDate).format('YYYY-MM-DD');
      this.dateRange.endDate = this.$moment(currentValue.endDate).format('YYYY-MM-DD');
      // this.$store.dispatch("layout/setDateRange", this.dateRange);
      this.$emit("update", currentValue);
    }
  }
};
</script>